import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import BasicInfoMobileWrapper from './MobileEditAccountWrapper/BasicInfoMobileWrapper';
import DietaryGoalsMobileWrapper from './MobileEditAccountWrapper/DietaryGoalsMobileWrapper';
import FitnessGoalsMobileWrapper from './MobileEditAccountWrapper/FitnessGoalsMobileWrapper';
import AdditioanlinfoMobileWrapper from './MobileEditAccountWrapper/AdditionInfoMobileWrapper';
import { useSelector } from 'react-redux';
import { selectToken } from '../user/userSlice';
import Window from '../../utils/Window';
import EditAccountPage from '../../pages/EditAccountPage';
import { selectIsMobileRoute } from '../mobile/mobileSlice';
import MyAccountPage from '../../pages/MyAccountPage';

export default function EditAccountMobileWrapper() {
    const navigate = useNavigate();
    const token = useSelector(selectToken);
    const AppURL = useSelector(selectIsMobileRoute);
    const QURLParams = AppURL ? `/?${AppURL}` : '/';

    if (!token || !Window.isMobile()) {
        if (!Window.isMobile()) {
            navigate(`/my-account/edit-account${QURLParams}`)
            return (
                <EditAccountPage />
            )
        }

        return (
            <MyAccountPage />
        )
    }
    return (
        <Routes>
            <Route path={'/basic-information/'} element={<BasicInfoMobileWrapper />} />
            <Route path={'/dietary-needs-goals/'} element={<DietaryGoalsMobileWrapper />} />
            <Route path={'/fitness-goals/'} element={<FitnessGoalsMobileWrapper />} />
            <Route path={'/additional-info/'} element={<AdditioanlinfoMobileWrapper />} />
        </Routes>
    )
}